import CollapseMediumIcon from "@entrilia/shared/icons/CollapseMediumIcon";
import ExpandMediumIcon from "@entrilia/shared/icons/ExpandMediumIcon";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import useToggleState from "@entrilia/shared/hooks/useToggleState";
import { isEmptyObject } from "@entrilia/shared/utilities/objectHelper";
import type { AggregatedDocumentViews } from "../../../../../api/types/documentActivityTypes";
import PageViewsChart from "../../../investor-portal/document-activity/PageViewsChart";

interface Props {
  aggregatedDocumentViews: AggregatedDocumentViews;
}

const TotalTimePerPageSection = ({ aggregatedDocumentViews }: Props) => {
  const [expanded, toggleExpanded] = useToggleState(true);

  if (isEmptyObject(aggregatedDocumentViews.pageViews)) {
    return null;
  }

  const title = aggregatedDocumentViews.totalDurationOfVideoFile
    ? "Total time spent per segment"
    : "Total time spent per page";

  return (
    <Box sx={{ pt: 4 }}>
      <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
        <IconButton onClick={toggleExpanded}>{expanded ? <CollapseMediumIcon /> : <ExpandMediumIcon />}</IconButton>
        <Typography variant="subtitle2" gutterBottom={false}>
          {title}
        </Typography>
      </Stack>
      {expanded && (
        <Box sx={{ display: "flex", justifyContent: "center", height: "12rem", width: "100%" }}>
          <PageViewsChart
            pageViews={aggregatedDocumentViews.pageViews}
            totalDurationOfVideoFile={aggregatedDocumentViews.totalDurationOfVideoFile}
          />
        </Box>
      )}
    </Box>
  );
};

export default TotalTimePerPageSection;
